import React from "react";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative w-full px-5 md:px-10 pt-16 pb-32 border-t border-zinc-900"
    >
      <div className="max-w-6xl mx-auto w-full">
        <div className="overflow-hidden">
          <h2 className="font-display font-black text-[19vw] md:text-[15vw] leading-[0.8] tracking-tighter text-white select-none">
            FRE3BRD
          </h2>
        </div>
        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 font-mono text-[11px] uppercase tracking-widest text-zinc-500">
          <span>Debut Mixtape · 10 Tracks</span>
          <button
            data-testid="back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 hover:text-white transition-colors"
          >
            Back to top <ArrowUp size={13} />
          </button>
          <span>© {new Date().getFullYear()} FRE3BRD</span>
        </div>
      </div>
    </footer>
  );
}
